"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isFunction = _interopRequireDefault(require("./isFunction"));

/**
 * Re map and given Map with a mapping function
 * @param {Map} inMap
 * @param {function} mappingFunction
 * @returns {Map}
 */
var mapToMap = function mapToMap(inMap, mappingFunction) {
  if (!(inMap instanceof Map)) {
    throw new Error('Can only convert Map to Map');
  }

  if (!(0, _isFunction["default"])(mappingFunction)) return inMap;
  var result = new Map();
  inMap.forEach(function (value, key) {
    result.set(key, mappingFunction(value, key));
  });
  return result;
};

var _default = mapToMap;
exports["default"] = _default;